import React , {useEffect , useState } from 'react'


import {  useLocation } from "react-router-dom";

import { ApiCallPost , ApiCallGet } from '../../ApiCall/ApiCall';

import Select from 'react-select';

export default function ClientDash() {

    const [registrado,setRegistrado] = useState(false)
    const [options,setOptions] = useState([/* { value : 1 , label : "uno"} , { value : 2 , label : "dos"} , { value : 3 , label : "tres"}*/] )
    const [selectedOption, setSelectedOption] = useState(null);

    const location = useLocation();


    console.log( "location = " , location ) 


    // get_lawyer_especialidades_express

    useEffect(() => {

        ApiCallGet("/get_especialidades_express")
        .then( (res) => {

            console.log( res )

            if ( res.length > 0 )
            {
                let aux = []

                res.map( (item) => {

                    aux.push( { value : item.id_especialidad , label : item.especialidad_name } )

                })

                setOptions( aux )

            }

        })
        .catch( (err) => {

            console.log( err )

        })


    },[])

    function onEspecialidadChange(e)
    {
        console.log( "Values = e.value" , e.value )
        setSelectedOption(e.value)
    }


    function onRegistrar()
    {
        console.log( "Registrando" )

        console.log( "id_client = " , location.state )

        if ( selectedOption === null && document.getElementById("comentario").value === "" )
        {
            alert("Seleccione una especialidad o comentario")
            return
        }

        //return ;

        ApiCallPost( "/client_set_agenda" , { id : location.state.id , 
            logg_express : !registrado , especialidad_express : selectedOption , 
            comentario_express : document.getElementById("comentario").value , date_express : new Date() } )
        .then( (res) => {

            console.log( res )

            if ( res.status === 0 )
            {
                setRegistrado( !registrado )
            }

        })
        .catch( (err) => {

            console.log( err )

        })

        
    }

    useEffect(() => {

        console.log( "ClientDash " + location.state.name + " logg_expres " +  location.state.logg_express )

        setRegistrado( location.state.logg_express )

    },[])


  return (

    <div className='box-1 backemployer-2 centersearch w-100 m-1 align-items-center' style={{height:'80vh' , marginTop :'50px'}} >
    <div className='d-flex flex-column  box-1 backemployer-2 mb-5 form-2 w-100' >

        <h4>
             Configuración Consulta Express Cliente
        </h4>

        <h4>
             Bienvenido {location.state?.name}
        </h4>

        <div className='row'>

            <div className='col-sm-6'>

                <label className="form-label m-0" htmlFor="especialidad">Especialidad Solicitada</label>

                <Select className='pt-2'
                    id="especialidad" 
                    options={options} onChange={onEspecialidadChange}
                     />


            </div>

            {/* <div className='col-sm-2'>

            </div> */}

            <div className='col-sm-6'>

                <label className="form-label m-0" htmlFor="comentario">Comentario</label>
                <textarea className="form-control" id="comentario" rows="3"></textarea>

               

            </div>



        </div>

        <div className='row  mt-4'>

            <div className='col-sm-4'>

                <p>Estado de consulta express</p>

            </div>

            <div className='col-sm-6 border-0 ' style={{border : '2px solid black' , height :'400px'}}>

                {/* <div   className='mt-4  pb-2  text-center' > */}
                    <button type="button" className={registrado ? "estilo_boton_selected" :"estilo_boton"} 
                        onClick={onRegistrar}>{registrado? "Solicitado" : "Solicitar"}
                        </button>
                {/* </div> */}
            </div>

        </div>

    </div>
    </div>


 
  )
}
